import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { workstationService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import toast from 'shared/utils/toast';
import { WorkstationForm } from '../components/WorkstationForm';
import { Workstation } from '../types';

const initWorkstation: Workstation = {
  id: null,
  code: '',
  description: '',
  sector: null
};
export const CreateWorkstation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const translationPrefix = 'pages.workstation.new';

  const dispatch = useAppDispatch();

  const onSubmit = async (values) => {
    dispatch(loadingActions.startLoading());
    workstationService.add(values).then(() => {
      toast.success('Workstation aggiunta con successo');
      navigate('..');
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <WorkstationForm workstation={initWorkstation} onSubmit={onSubmit} />
    </TenantPage>
  );
};

export default CreateWorkstation;
